// A mother's consent to calls and WhatsApp (CLAUDE.md rule 19). Frontend copy of consentStatusOf in
// functions/src/calling/consent.ts: keep the two the same.
//
// - Reception's tick (`consent.given`) means only that she AGREED VERBALLY; her status starts as pending.
// - "yes" comes from her own reply: WhatsApp Yes, a signed paper form, or the start of Asha's first call.
// - Stopping at any time sets status "no".
import type { ConsentStatus, Mother } from '../types';

type ConsentFacts = Pick<Mother, 'consent' | 'consentStatus' | 'optedOut'>;

const STATUSES: ConsentStatus[] = ['pending', 'yes', 'no'];

/** Her consent status. Records from before 30 Oct 2026 have only the tick, which then meant full consent. */
export function consentStatusOf(m: ConsentFacts): ConsentStatus {
  if (m.optedOut === true) return 'no';
  if (m.consentStatus && STATUSES.includes(m.consentStatus)) return m.consentStatus;
  return m.consent?.given === true ? 'yes' : 'pending';
}

/** Version label for the clinic's signed paper consent form, from the doctor-approved consent text version. */
export const paperConsentVersion = (signedVersion?: number) => `paper-v${signedVersion ?? 1}`;
